import { createClient } from '@supabase/supabase-js';

// Prefer Vite-style, fallback to CRA-style for compatibility
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

console.log('CRA SUPABASE_URL:', supabaseUrl);
console.log('CRA SUPABASE_ANON_KEY:', supabaseAnonKey);

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('[Supabase] Missing URL or anon key! Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env.local.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
